import { Inject, Injectable, Optional } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ADDITIONAL_SERVICES_DEBOUNCE_TIME } from '@shared/tokens';
import {
  ActionTypes as AdditionalServicesActionTypes,
  GetMenu,
  SetMenu
} from '@store/additional-services/additional-services.actions';
import { MenuList } from '@store/additional-services/additional-services.model';
import { AdditionalServicesService } from '@store/additional-services/additional-services.service';
import { EMPTY, of } from 'rxjs';
import { catchError, debounceTime, map, switchMap } from 'rxjs/operators';

@Injectable()
export class AdditionalServicesEffect {
  loadMenu$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetMenu>(AdditionalServicesActionTypes.GET_MENU),
      debounceTime(this.additionalServicesDebounceTime),
      switchMap((data: GetMenu) => {
        const eventId = data.payload;
        if (!eventId) {
          return EMPTY;
        }

        return this.additionalServicesService.getMenu(eventId).pipe(
          map((menuOptions: MenuList) => new SetMenu(menuOptions)),
          catchError((error) => {
            console.log(error);
            return of(new SetMenu([]));
          })
        );
      })
    )
  );

  constructor(
    @Optional() @Inject(ADDITIONAL_SERVICES_DEBOUNCE_TIME) private additionalServicesDebounceTime: number,
    private actions$: Actions,
    private additionalServicesService: AdditionalServicesService
  ) {}
}
